import { t, useI18n } from "@bookingcom/lingojs-react";
import { UIFlightData } from "@flights/types";
import useProfiler from "../../../../../../../hooks/useProfiler";
import { useMemo } from "react";
import { compressSameTypeBaggage } from "./compressSameTypeBaggage";

const useBaggageInfoController = (flight: UIFlightData) => {
  const i18n = useI18n();
  const { isAmerican } = useProfiler();

  const { segments, includedProducts, baggagePolicies } = flight;

  /* start - flights_web_remove_baggage_weight_size_fd */
  const includedProductsCompressed = useMemo(() => compressSameTypeBaggage(includedProducts), [includedProducts]);
  /* end - flights_web_remove_baggage_weight_size_fd */

  return {
    header: i18n.trans(t("flights_included_baggage_title")),
    subheader: i18n.trans(t("flights_included_baggage_sub")),
    segments,
    includedProducts: Boolean(includedProducts?.segments.some((segment) => segment.length > 0))
      ? includedProducts
      : undefined,
    /* start - flights_web_remove_baggage_weight_size_fd */
    includedProductsCompressed,
    /* end - flights_web_remove_baggage_weight_size_fd */
    baggagePolicies: baggagePolicies && isAmerican() ? baggagePolicies : undefined
  };
};

export default useBaggageInfoController;
